import { Box, Skeleton, useTheme } from "@mui/material"

export const SkeletonStepByStepSidebar = () => {
  const theme = useTheme()
  const {
    root,
    headerWrapper,
    locationAvatar,
    locationText,
    stepContainer,
    stepListContainer,
    actionContainer,
    startButton,
  } = theme.components[`SkeletonStepByStepSidebar`]?.styleOverrides || {}

  return (
    <Box sx={root}>
      <Box sx={headerWrapper}>
        <Skeleton sx={locationAvatar} variant="rounded" />
        <Skeleton sx={locationText} variant="text" />
      </Box>
      <Box sx={stepContainer}>
        <Skeleton sx={stepListContainer} variant="rounded" />
      </Box>
      <Box sx={actionContainer}>
        <Skeleton sx={startButton} variant="rounded" />
        <Skeleton sx={startButton} variant="rounded" />
      </Box>
    </Box>
  )
}
